// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const creditLinkagePage = "CreditLinkagePage__creditLinkagePage__TlhcK";
export const footer = "CreditLinkagePage__footer__YvvvQ";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const linkage = "CreditLinkagePage__linkage__jG5qO";
export const linked = "CreditLinkagePage__linked__HBs-Z";
export const main = "CreditLinkagePage__main__YLfhA";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "CreditLinkagePage__textCenter__su7IV";